import { EditorModes, matchLayerIdentifier, ReviewType } from "@buildwithflux/models";
import { getTopLevelLayouts } from "../../nodes";
import { getProblemTypeKeyFromReviewType } from "../types";
export class InvalidLayerValidator {
    reviewType = ReviewType.DesignRuleCheckInvalidLayer;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    async checkForProblems({ pcbLayoutNodes }) {
        const layouts = getTopLevelLayouts(pcbLayoutNodes);
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems: layouts.flatMap((layout) => {
                const stackup = layout?.bakedRules?.stackup ?? {};
                const stackupValues = Object.values(stackup);
                const nodesWithInvalidLayerUids = [];
                for (const uid in pcbLayoutNodes ?? {}) {
                    const foundLayer = stackupValues.find((layer) => {
                        return matchLayerIdentifier(layer, pcbLayoutNodes[uid].bakedRules?.layer);
                    });
                    if (!foundLayer) {
                        nodesWithInvalidLayerUids.push(uid);
                    }
                }
                return nodesWithInvalidLayerUids.map((uid) => ({
                    problemTypeKey: this.problemTypeKey,
                    key: `${this.problemTypeKey}_${uid}`,
                    affectedItems: [{ type: "pcbLayoutNode", uid }],
                    affectedViews: [EditorModes.pcb],
                }));
            }),
        };
    }
}
//# sourceMappingURL=InvalidLayerValidator.js.map